module.exports = __webpack_public_path__ + "img/cst1.03d3df28.png";